// Generated from split view template sources. Keep source edits in public/view-*-template.js.

window.__viewTimingTemplate = String.raw`
<div id="errorPanel" class="errors" style="display:none;"></div>

<div class="panel">
    <div class="panel-heading">
        <h2>チャート編集</h2>
        <div class="panel-heading-actions">
            <div class="toolbar-popover">
                <button id="btnAddAxis" type="button" class="panel-action-btn" aria-expanded="false" aria-controls="axisAddPopover">＋ 軸追加</button>
                <div id="axisAddPopover" class="axis-popover" role="dialog" aria-label="軸追加">
                    <div class="axis-popover-title">軸を追加</div>
                    <p class="axis-popover-help">候補からすぐ追加するか、任意の軸名を入力して追加できます。</p>
                    <div class="axis-popover-presets">
                        <button type="button" class="axis-preset-button" data-axis-preset="X軸">X軸</button>
                        <button type="button" class="axis-preset-button" data-axis-preset="Y軸">Y軸</button>
                        <button type="button" class="axis-preset-button" data-axis-preset="Z軸">Z軸</button>
                        <button type="button" class="axis-preset-button" data-axis-preset="R軸">R軸</button>
                        <button type="button" class="axis-preset-button" data-axis-preset="搬送軸">搬送軸</button>
                        <button type="button" class="axis-preset-button" data-axis-preset="昇降軸">昇降軸</button>
                    </div>
                    <div class="axis-popover-form">
                        <input id="axisAddNameInput" type="text" placeholder="カスタム軸名を入力">
                        <label class="axis-popover-field">アクチュエータ種類
                            <select id="axisAddActuatorTypeSelect">
                                <option value="pneumaticCylinder">空圧シリンダ</option>
                                <option value="hydraulicCylinder">油圧シリンダ</option>
                                <option value="electricCylinder">電動シリンダ</option>
                                <option value="motor">モータ</option>
                                <option value="chuck">チャック</option>
                                <option value="vacuum">バキューム</option>
                                <option value="heater">ヒータ</option>
                                <option value="generic">汎用I/O</option>
                            </select>
                        </label>
                        <label class="axis-popover-field">モータ制御種別
                            <select id="axisAddMotorControlTypeSelect">
                                <option value="speedControl">速度指定モータ</option>
                                <option value="pulseCommand">パルスモータ（コマンド入力）</option>
                                <option value="pulseTrain">パルスモータ（パルス入力）</option>
                                <option value="servo">サーボモータ</option>
                                <option value="inverter">インバータ</option>
                            </select>
                        </label>
                        <div class="axis-popover-actions">
                            <button id="btnAxisAddCancel" type="button" class="secondary">閉じる</button>
                            <button id="btnAxisAddConfirm" type="button">追加</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="timing-area">
        <div class="timing-grid" id="timingGrid"></div>
    </div>
</div>

<div class="panel">
    <h2>選択軸の速度線図</h2>
    <div id="speedChartLabel" class="help">軸を選択すると、その軸の動作を順に並べた速度線図を表示します。</div>
    <canvas id="speedChart"></canvas>
</div>
`;

window.__viewFlowTemplate = String.raw`
<div class="panel">
    <div id="flowTabs" class="flow-tabs" aria-label="フロータブ"></div>
    <div class="flow-toolbar">
        <div class="flow-axis-row">
            <div class="flow-axis-selector">
                <span class="flow-toolbar-label">軸</span>
                <select id="flowAxisSelect"></select>
                <div class="toolbar-popover">
                    <button id="btnFlowAddAxis" type="button" class="axis-icon-btn"
                            title="軸を追加" aria-expanded="false" aria-controls="flowAxisAddPopover">＋</button>
                    <div id="flowAxisAddPopover" class="axis-popover" role="dialog" aria-label="軸を追加">
                        <div class="axis-popover-title">軸を追加</div>
                        <div class="axis-popover-presets">
                            <button type="button" class="axis-preset-button" data-flow-axis-preset="X軸">X軸</button>
                            <button type="button" class="axis-preset-button" data-flow-axis-preset="Y軸">Y軸</button>
                            <button type="button" class="axis-preset-button" data-flow-axis-preset="Z軸">Z軸</button>
                            <button type="button" class="axis-preset-button" data-flow-axis-preset="R軸">R軸</button>
                            <button type="button" class="axis-preset-button" data-flow-axis-preset="搬送軸">搬送軸</button>
                            <button type="button" class="axis-preset-button" data-flow-axis-preset="昇降軸">昇降軸</button>
                        </div>
                        <div class="axis-popover-form">
                            <input id="flowAxisAddNameInput" type="text" placeholder="カスタム軸名">
                            <label class="axis-popover-field">アクチュエータ種類
                                <select id="flowAxisAddActuatorTypeSelect">
                                    <option value="pneumaticCylinder">空圧シリンダ</option>
                                    <option value="hydraulicCylinder">油圧シリンダ</option>
                                    <option value="electricCylinder">電動シリンダ</option>
                                    <option value="motor">モータ</option>
                                    <option value="chuck">チャック</option>
                                    <option value="vacuum">バキューム</option>
                                    <option value="heater">ヒータ</option>
                                    <option value="generic">汎用I/O</option>
                                </select>
                            </label>
                            <label class="axis-popover-field">モータ制御種別
                                <select id="flowAxisAddMotorControlTypeSelect">
                                    <option value="speedControl">速度指定モータ</option>
                                    <option value="pulseCommand">パルスモータ（コマンド入力）</option>
                                    <option value="pulseTrain">パルスモータ（パルス入力）</option>
                                    <option value="servo">サーボモータ</option>
                                    <option value="inverter">インバータ</option>
                                </select>
                            </label>
                            <div class="axis-popover-actions">
                                <button id="btnFlowAxisAddCancel" type="button" class="secondary">閉じる</button>
                                <button id="btnFlowAxisAddConfirm" type="button">追加</button>
                            </div>
                        </div>
                    </div>
                </div>
                <button id="btnFlowRemoveAxis" type="button" class="axis-icon-btn secondary"
                        title="この軸を削除">×</button>
            </div>
            <button id="btnClearFlowPalette" type="button" class="secondary" title="現在のフローを一括クリア" aria-label="現在のフローを一括クリア">一括クリア</button>
        </div>
        <div class="flow-node-add-group" aria-label="ノード追加">
            <span class="flow-toolbar-label">ノード追加:</span>
            <span class="flow-node-section-label">流れ</span>
            <button id="btnAddStartNode" type="button" class="secondary" title="フローの開始位置を表す開始ノードを追加" aria-label="フローの開始位置を表す開始ノードを追加"><span class="flow-node-icon" aria-hidden="true">▶</span>開始</button>
            <button id="btnAddEndNode" type="button" class="secondary" title="正常完了や停止位置を表す終了ノードを追加" aria-label="正常完了や停止位置を表す終了ノードを追加"><span class="flow-node-icon" aria-hidden="true">■</span>終了</button>
            <span class="flow-node-section-label">処理</span>
            <button id="btnAddFlowMotion" type="button" class="secondary" title="選択中の軸の動作ノードを追加" aria-label="選択中の軸の動作ノードを追加"><span class="flow-node-icon" aria-hidden="true">↔</span>動作</button>
            <button id="btnAddSubprocessNode" type="button" class="secondary" title="別タブで定義したサブプロセス呼び出しノードを追加" aria-label="別タブで定義したサブプロセス呼び出しノードを追加"><span class="flow-node-icon" aria-hidden="true">⧉</span>サブプロセス</button>
            <span class="flow-node-section-label">判定・入力</span>
            <button id="btnAddConditionNode" type="button" class="secondary" title="ON / OFF / TIMEOUT の3分岐を持つ条件ノードを追加" aria-label="ON / OFF / TIMEOUT の3分岐を持つ条件ノードを追加"><span class="flow-node-icon" aria-hidden="true">◇</span>条件</button>
            <button id="btnAddButtonNode" type="button" class="secondary" title="押しボタンやスイッチなどの操作入力ノードを追加" aria-label="押しボタンやスイッチなどの操作入力ノードを追加"><span class="flow-node-icon" aria-hidden="true">●</span>操作入力</button>
            <span class="flow-node-section-label">出力</span>
            <button id="btnAddSignalOutputNode" type="button" class="secondary" title="ランプ、ブザー、内部フラグなどをON/OFF/点滅させる信号操作ノードを追加" aria-label="ランプ、ブザー、内部フラグなどをON/OFF/点滅させる信号操作ノードを追加"><span class="flow-node-icon" aria-hidden="true">⇧</span>信号操作</button>
            <button id="btnAddWaitNode" type="button" class="secondary" title="一定時間待機する wait/hold ノードを追加" aria-label="一定時間待機する wait/hold ノードを追加"><span class="flow-node-icon" aria-hidden="true">⏱</span>待機</button>
            <button id="btnAddErrorNode" type="button" class="secondary" title="タイムアウトや異常時の遷移先になるエラーノードを追加" aria-label="タイムアウトや異常時の遷移先になるエラーノードを追加"><span class="flow-node-icon" aria-hidden="true">!</span>エラー</button>
        </div>
    </div>
    <div class="flow-canvas-shell">
        <div id="drawflow-container"></div>
        <div class="flow-canvas-overlay">
            <span id="flowConnectionHint" class="flow-connection-hint" aria-live="polite"></span>
            <div class="flow-overlay-actions">
                <span class="flow-connect-label">接続</span>
                <div class="flow-connect-mode-group" role="group" aria-label="接続方法">
                    <button id="btnFlowConnectDrag" type="button" class="secondary flow-connect-mode-btn" aria-label="ドラッグ接続" aria-pressed="false" data-flow-tooltip="端子をそのままドラッグ" title="端子をそのままドラッグ"><span class="flow-connect-mode-icon" aria-hidden="true"><svg viewBox="0 0 48 24" focusable="false"><path class="flow-connect-icon-line flow-connect-icon-line-strong" d="M12 12C18 5.5 30 18.5 36 12"></path><circle class="flow-connect-icon-ring" cx="10" cy="12" r="8"></circle><circle class="flow-connect-icon-dot" cx="10" cy="12" r="5"></circle><circle class="flow-connect-icon-ring" cx="38" cy="12" r="8"></circle><circle class="flow-connect-icon-dot" cx="38" cy="12" r="5"></circle></svg></span></button>
                    <button id="btnFlowConnectPick" type="button" class="secondary flow-connect-mode-btn" aria-label="2点選択接続" aria-pressed="false" data-flow-tooltip="出力 -> 入力を順にクリック" title="出力 -> 入力を順にクリック"><span class="flow-connect-mode-icon" aria-hidden="true"><svg viewBox="0 0 48 24" focusable="false"><path class="flow-connect-icon-line flow-connect-icon-line-dashed" d="M17 12H31"></path><circle class="flow-connect-icon-ring" cx="10" cy="12" r="8"></circle><circle class="flow-connect-icon-badge" cx="10" cy="12" r="5.2"></circle><circle class="flow-connect-icon-ring" cx="38" cy="12" r="8"></circle><circle class="flow-connect-icon-badge" cx="38" cy="12" r="5.2"></circle><text class="flow-connect-icon-text" x="10" y="15.1">1</text><text class="flow-connect-icon-text" x="38" y="15.1">2</text></svg></span></button>
                </div>
            </div>
        </div>
    </div>
    <div id="flowNodeEditor" class="flow-node-editor"></div>
</div>
`;

window.__viewSkillsTemplate = String.raw`
<div class="skills-layout">
    <div class="panel skills-sidebar-panel">
        <div class="skills-panel-header">
            <h2>Skills</h2>
            <div class="skills-panel-actions">
                <button id="btnReloadSkills" type="button" class="skills-reload-btn" title="Skills一覧を再読み込み" aria-label="Skills一覧を再読み込み">↻</button>
            </div>
        </div>
        <div class="skills-sidebar-tabs" role="tablist" aria-label="Skills表示">
            <button id="btnSkillsSidebarTabCatalog" type="button" class="skills-catalog-tab is-active" aria-selected="true" title="一覧から確認・追加・共有できます。">Skill一覧</button>
            <button id="btnSkillsSidebarTabProject" type="button" class="skills-catalog-tab" aria-selected="false" title="このプロジェクトで使うSkillです。">使用中Skill</button>
        </div>
        <div id="skillsSidebarCatalogPanel" class="skills-sidebar-section">
            <div class="skills-catalog-tabs" role="tablist" aria-label="Skill種別">
                <button id="btnSkillsCatalogTabBuiltin" type="button" class="skills-catalog-tab is-active" aria-selected="true" title="標準で使えるSkillを表示します。">標準Skill</button>
                <button id="btnSkillsCatalogTabCustom" type="button" class="skills-catalog-tab" aria-selected="false" title="自分のSkillや共有Skillを表示します。">カスタムSkill</button>
            </div>
            <div class="custom-skills-toolbar">
                <input id="skillCatalogSearchInput" type="search" placeholder="Skillを検索">
                <select id="skillCatalogSortSelect">
                    <option value="nameAsc">名前順</option>
                    <option value="nameDesc">名前逆順</option>
                    <option value="updatedDesc">更新が新しい順</option>
                    <option value="updatedAsc">更新が古い順</option>
                </select>
            </div>
            <div id="skillsCatalogBuiltinPanel" class="skills-catalog-panel">
                <div id="builtinSkillsCatalogListContainer" class="skills-list skills-catalog-list">
                    <p class="help">読み込み中...</p>
                </div>
            </div>
            <div id="skillsCatalogCustomPanel" class="skills-catalog-panel" hidden>
                <div class="custom-skills-toolbar">
                    <button id="btnCreateCustomSkill" type="button" class="secondary skills-soft-button">カスタムSkillを作成</button>
                    <span id="customSkillsStatus" class="text-muted-sm ctrl-spec-ml"></span>
                </div>
                <p class="help">新規作成されたカスタムSkillは private + draft で保存されます。</p>
                <section class="skill-category-section">
                    <div class="skill-category-title">自分のSkill</div>
                    <div id="customOwnSkillsListContainer" class="skills-list skills-catalog-list">
                        <p class="help">まだカスタムSkillがありません。</p>
                    </div>
                </section>
                <section class="skill-category-section custom-shared-skills-section">
                    <div class="skill-category-title">組織共有Skill</div>
                    <p id="customSharedSkillsHelp" class="help">組織に共有したSkillがここに表示されます。</p>
                    <div id="customSharedSkillsListContainer" class="skills-list skills-catalog-list">
                        <p class="help">まだ利用できません。</p>
                    </div>
                </section>
            </div>
        </div>
        <div id="skillsSidebarProjectPanel" class="skills-sidebar-section" hidden>
            <div id="skillsListContainer" class="skills-list">
                <p class="help">読み込み中...</p>
            </div>
            <div class="skills-actions ctrl-spec-toolbar-sep">
                <span id="projectSkillsStatus" class="text-muted-sm ctrl-spec-ml"></span>
            </div>
        </div>
    </div>
    <div class="panel skills-detail-panel">
        <h2 id="skillsEditorTitle" title="Claude Skills 形式の Markdown を編集します。一覧からSkillを選択してください。">SKILL.md エディタ</h2>
        <div class="skill-meta-form">
            <label class="skill-meta-field">
                <span>Skill名</span>
                <input id="skillNameInput" type="text" placeholder="Skill名">
            </label>
            <label class="skill-meta-field">
                <span>説明</span>
                <input id="skillDescriptionInput" type="text" placeholder="説明">
            </label>
            <label class="skill-meta-field skill-meta-field-compact">
                <span>status</span>
                <select id="skillStatusSelect">
                    <option value="draft">draft</option>
                    <option value="published">published</option>
                </select>
            </label>
            <div id="skillVisibilityNote" class="skill-visibility-note">公開範囲: private</div>
            <div id="skillCreatedByNote" class="skill-visibility-note">作成者: -</div>
            <div id="skillUpdatedByNote" class="skill-visibility-note">更新者: -</div>
            <div id="skillUpdatedAtNote" class="skill-visibility-note">更新日時: -</div>
        </div>
        <textarea
            id="skillContentEditor"
            class="skill-markdown-editor"
            spellcheck="false"
            placeholder="一覧からSkillを選択すると、ここにSKILL.md本文が表示されます。"
        ></textarea>
        <div class="skills-actions skills-editor-actions ctrl-spec-toolbar-sep">
            <span id="skillEditorStatus" class="text-muted-sm"></span>
            <div class="skills-editor-button-row">
                <button id="btnDeleteSkill" type="button" class="secondary skills-soft-button skills-soft-button-danger">削除</button>
                <button id="btnSaveSkillContent" type="button" class="primary skills-primary-action">Skillを保存</button>
            </div>
        </div>
    </div>
</div>
`;

window.__viewSettingsTemplate = String.raw`
<div class="settings-grid">
    <div class="panel">
        <h2>単位設定</h2>
        <div class="unit-block">
            <label>移動距離(直線): <select id="distanceLinearUnit">
                <option value="mm" selected>mm</option>
                <option value="m">m</option>
            </select></label>
            <label>加速度(直線): <select id="accelLinearUnit">
                <option value="m/s2" selected>m/s²</option>
                <option value="G">G</option>
            </select></label>
            <label>最高速度(直線): <select id="speedLinearUnit">
                <option value="mm/s" selected>mm/s</option>
                <option value="m/s">m/s</option>
            </select></label>
            <label>移動角度(回転): <select id="angleRotaryUnit">
                <option value="deg" selected>deg</option>
                <option value="rad">rad</option>
            </select></label>
            <label>加速度(回転): <select id="accelRotaryUnit">
                <option value="deg/s2" selected>deg/s²</option>
                <option value="rad/s2">rad/s²</option>
            </select></label>
            <label>最高速度(回転): <select id="speedRotaryUnit">
                <option value="deg/s" selected>deg/s</option>
                <option value="rad/s">rad/s</option>
            </select></label>
        </div>
        <div class="toolbar ctrl-spec-toolbar-sep">
            <button id="btnSaveAccountSettings" class="secondary" disabled title="ログインが必要です">アカウントのデフォルトに設定</button>
            <span id="accountSettingsStatus" class="text-muted-sm ctrl-spec-ml"></span>
        </div>
    </div>

    <div class="panel">
        <h2>アカウント</h2>
        <div class="help ctrl-spec-panel-help">クラウドのログイン状態と操作は左下のアカウント欄に表示されます。</div>
        <div class="help ctrl-spec-panel-help">ここではアカウント既定値の保存だけを扱います。</div>
    </div>

    <div class="panel">
        <h2>信号カテゴリ</h2>
        <div class="help ctrl-spec-panel-help">信号の用途分類とIECアドレス採番範囲を管理します。</div>
        <div id="control-spec-tabpanel-signal-categories" class="control-spec-tabpanel" role="region" aria-label="信号カテゴリ" style="display: flex; flex-direction: column; gap: 15px; padding: 0;">
            <div class="control-spec-left-panel" style="display: flex; flex-direction: column; min-width: 0;">
                <div class="control-spec-toolbar ctrl-spec-toolbar-mb">
                    <button id="btnControlSpecAddSignalCategory" type="button" class="primary">＋ カテゴリ追加</button>
                </div>
                <div class="control-spec-table-wrapper signal-category-table-wrapper" style="overflow-x: auto; overflow-y: auto; max-height: 320px; border: 1px solid #ddd; border-radius: 4px; background: #fff;">
                    <table class="control-spec-table ctrl-spec-table">
                        <thead>
                            <tr class="ctrl-spec-thead-tr">
                                <th class="ctrl-spec-th">ID</th>
                                <th class="ctrl-spec-th">名称</th>
                                <th class="ctrl-spec-th">初期方向</th>
                                <th class="ctrl-spec-th">IEC接頭辞</th>
                                <th class="ctrl-spec-th">開始バイト</th>
                                <th class="ctrl-spec-th ctrl-spec-th-action">操作</th>
                            </tr>
                        </thead>
                        <tbody id="controlSpecSignalCategoriesTableBody">
                            <!-- 行データが動的に挿入されます -->
                        </tbody>
                    </table>
                </div>
            </div>

            <div id="controlSpecSignalCategoryFormPanel" class="control-spec-right-panel" style="border: 1px solid #ddd; border-radius: 6px; padding: 15px; background: #fdfdfd; display: flex; flex-direction: column; gap: 12px; min-width: 0; box-shadow: 0 1px 3px rgba(0,0,0,0.05);">
                <h3 id="controlSpecSignalCategoryFormTitle" class="ctrl-spec-section-title">カテゴリを追加</h3>
                <div id="controlSpecSignalCategoryFormError" class="error-msg ctrl-spec-error-msg"></div>

                <div class="form-group ctrl-spec-form-col">
                    <label for="inputSignalCategoryId" class="ctrl-spec-label">カテゴリID <span class="text-danger">*</span></label>
                    <input type="text" id="inputSignalCategoryId" placeholder="例: sensor" class="ctrl-spec-input">
                </div>

                <div class="form-group ctrl-spec-form-col">
                    <label for="inputSignalCategoryName" class="ctrl-spec-label">名称 <span class="text-danger">*</span></label>
                    <input type="text" id="inputSignalCategoryName" placeholder="例: センサ入力" class="ctrl-spec-input">
                </div>

                <div class="form-row ctrl-spec-flex-gap">
                    <div class="form-group ctrl-spec-form-col1 ctrl-spec-form-col">
                        <label for="selectSignalCategoryDirection" class="ctrl-spec-label">初期方向</label>
                        <select id="selectSignalCategoryDirection" class="ctrl-spec-input">
                            <option value="input">input</option>
                            <option value="output">output</option>
                            <option value="internal">internal</option>
                        </select>
                    </div>
                    <div class="form-group ctrl-spec-form-col1 ctrl-spec-form-col">
                        <label for="selectSignalCategoryAddressPrefix" class="ctrl-spec-label">IEC接頭辞</label>
                        <select id="selectSignalCategoryAddressPrefix" class="ctrl-spec-input">
                            <option value="%IX">%IX</option>
                            <option value="%QX">%QX</option>
                            <option value="%MX">%MX</option>
                            <option value="%IW">%IW</option>
                            <option value="%QW">%QW</option>
                            <option value="%MW">%MW</option>
                            <option value="%ID">%ID</option>
                            <option value="%QD">%QD</option>
                            <option value="%MD">%MD</option>
                        </select>
                    </div>
                </div>

                <div class="form-group ctrl-spec-form-col">
                    <label for="inputSignalCategoryStartByte" class="ctrl-spec-label">開始バイト</label>
                    <input type="number" id="inputSignalCategoryStartByte" min="0" step="1" placeholder="例: 0" class="ctrl-spec-input">
                </div>

                <div class="form-actions ctrl-spec-form-actions">
                    <button id="btnControlSpecCancelSignalCategory" type="button" class="secondary secondary">キャンセル</button>
                    <button id="btnControlSpecSaveSignalCategory" type="button" class="primary" style="background: #28a745;">保存</button>
                </div>
            </div>
        </div>
    </div>

    <div class="panel">
        <h2>アクチュエータ種類マスタ</h2>
        <div class="help ctrl-spec-panel-help">種類名と既定アクション候補をここで追加・編集します。</div>
        <div style="border: 1px solid #e6ecf3; border-radius: 6px; padding: 12px; background: #f8fbff; display: flex; flex-direction: column; gap: 8px;">
            <div style="display: flex; justify-content: space-between; align-items: center; gap: 8px;">
                <div style="font-weight: bold; color: #334;">種類一覧</div>
                <button id="btnControlSpecAddActuatorTypeCatalog" type="button" style="padding: 4px 8px; font-size: 0.8em; font-weight: bold; border-radius: 4px; border: 1px solid #007bff; background: #fff; color: #007bff; cursor: pointer;">＋ 種類追加</button>
            </div>
            <div class="form-group ctrl-spec-form-col">
                <label for="selectActuatorTypeCatalogEntry" class="ctrl-spec-label-xs">編集対象</label>
                <select id="selectActuatorTypeCatalogEntry" class="ctrl-spec-input-md"></select>
            </div>
            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 8px;">
                <div class="form-group ctrl-spec-form-col">
                    <label for="inputActuatorTypeCatalogId" class="ctrl-spec-label-xs">種類ID</label>
                    <input id="inputActuatorTypeCatalogId" type="text" placeholder="例: clamp" class="ctrl-spec-input-md">
                </div>
                <div class="form-group ctrl-spec-form-col">
                    <label for="inputActuatorTypeCatalogLabel" class="ctrl-spec-label-xs">表示名</label>
                    <input id="inputActuatorTypeCatalogLabel" type="text" placeholder="例: クランプ" class="ctrl-spec-input-md">
                </div>
            </div>
            <div class="form-group ctrl-spec-form-col">
                <label for="inputActuatorTypeCatalogActions" class="ctrl-spec-label-xs">既定アクション候補</label>
                <input id="inputActuatorTypeCatalogActions" type="text" placeholder="例: 前進, 後退, チャック" class="ctrl-spec-input-md">
            </div>
            <div class="help" id="controlSpecActuatorTypeCatalogMeta" style="margin: 0; font-size: 0.8em;"></div>
            <div style="display: flex; justify-content: flex-end; gap: 8px;">
                <button id="btnControlSpecDeleteActuatorTypeCatalog" type="button" style="padding: 5px 10px; border-radius: 4px; border: 1px solid #dc3545; background: #fff; color: #dc3545; cursor: pointer;">削除</button>
                <button id="btnControlSpecSaveActuatorTypeCatalog" type="button" style="padding: 5px 10px; border-radius: 4px; border: none; background: #198754; color: #fff; cursor: pointer;">保存</button>
            </div>
        </div>
    </div>

</div>
`;

window.__viewControlSpecTemplate = String.raw`
                    <div class="control-spec-layout" style="display: flex; flex-direction: column; gap: 15px; height: 100%; padding: 15px;">
                        <div class="control-spec-panels" style="flex: 1; min-height: 0;">
                            <!-- 信号辞書タブ -->
                            <div id="control-spec-tabpanel-signals" class="control-spec-tabpanel panel is-active" role="tabpanel" aria-hidden="false" style="height: 100%; display: flex; flex-direction: row; gap: 15px; padding: 10px;">
                                <!-- 左：信号一覧テーブル -->
                                <div class="control-spec-left-panel" style="flex: 7; display: flex; flex-direction: column; min-width: 0;">
                                    <div class="control-spec-toolbar ctrl-spec-toolbar-mb">
                                        <button id="btnControlSpecAddSignal" type="button" class="primary">＋ 信号追加</button>
                                        <span class="help ctrl-spec-panel-help">I/O表やST生成の基準となる信号一覧です。</span>
                                        <span id="controlSpecSignalsMeta" class="help ctrl-spec-meta-right"></span>
                                    </div>
                                    <div class="control-spec-table-wrapper ctrl-spec-scroll-y">
                                        <table class="control-spec-table ctrl-spec-table">
                                            <thead>
                                                <tr class="ctrl-spec-thead-tr">
                                                    <th class="ctrl-spec-th">ID</th>
                                                    <th class="ctrl-spec-th">名称</th>
                                                    <th class="ctrl-spec-th">カテゴリ</th>
                                                    <th class="ctrl-spec-th">方向</th>
                                                    <th class="ctrl-spec-th">アドレス</th>
                                                    <th class="ctrl-spec-th">データ型</th>
                                                    <th class="ctrl-spec-th">Active</th>
                                                    <th class="ctrl-spec-th">所属アクチュエータ</th>
                                                    <th class="ctrl-spec-th">説明</th>
                                                    <th class="ctrl-spec-th ctrl-spec-th-action">操作</th>
                                                </tr>
                                            </thead>
                                            <tbody id="controlSpecSignalsTableBody">
                                                <!-- 行データが動的に挿入されます -->
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                
                                <!-- 右：追加・編集フォーム -->
                                <div id="controlSpecSignalFormPanel" class="control-spec-right-panel" style="flex: 3; border: 1px solid #ddd; border-radius: 6px; padding: 15px; background: #fdfdfd; display: flex; flex-direction: column; gap: 12px; min-width: 280px; box-shadow: 0 1px 3px rgba(0,0,0,0.05);">
                                    <h3 id="controlSpecSignalFormTitle" class="ctrl-spec-section-title">信号を追加</h3>
                                    <div id="controlSpecSignalFormError" class="error-msg ctrl-spec-error-msg"></div>

                                    <div class="form-group" style="display: flex; flex-direction: column; gap: 6px;">
                                        <label class="ctrl-spec-label">フロー候補から取り込む</label>
                                        <div style="display: flex; flex-direction: column; gap: 8px; min-width: 0;">
                                            <select id="selectControlSpecFlowSignalCandidate" style="width: 100%; min-width: 0; padding: 6px; border: 1px solid #ccc; border-radius: 4px; font-size: 0.9em;">
                                                <option value="">条件分岐や信号操作から選択</option>
                                            </select>
                                            <button id="btnControlSpecApplyFlowCandidate" type="button" class="secondary" style="align-self: flex-end; padding: 6px 12px; font-weight: bold; border-radius: 4px;">取り込む</button>
                                        </div>
                                        <span class="help" style="font-size: 0.82em; color: #666;">条件分岐や信号操作の内容を信号一覧へ下書き反映します。</span>
                                    </div>

                                    <div class="form-group ctrl-spec-form-col">
                                        <label for="inputSignalId" class="ctrl-spec-label">信号ID <span class="text-danger">*</span></label>
                                        <input type="text" id="inputSignalId" placeholder="例: X_Sensor (英数字/アンダースコア)" class="ctrl-spec-input">
                                    </div>

                                    <div class="form-group ctrl-spec-form-col">
                                        <label for="inputSignalName" class="ctrl-spec-label">名称 <span class="text-danger">*</span></label>
                                        <input type="text" id="inputSignalName" placeholder="例: ワーク検出センサ" class="ctrl-spec-input">
                                    </div>

                                    <div class="form-group ctrl-spec-form-col">
                                        <label for="inputSignalIecName" class="ctrl-spec-label">IEC変数名</label>
                                        <input type="text" id="inputSignalIecName" placeholder="例: WorkDetected" class="ctrl-spec-input">
                                    </div>

                                    <div class="form-group ctrl-spec-form-col">
                                        <label for="selectSignalCategory" class="ctrl-spec-label">カテゴリ</label>
                                        <select id="selectSignalCategory" class="ctrl-spec-input">
                                            <!-- 信号カテゴリが動的に挿入されます -->
                                        </select>
                                    </div>

                                    <div class="form-group ctrl-spec-form-col">
                                        <label for="selectSignalDirection" class="ctrl-spec-label">方向 <span class="text-danger">*</span></label>
                                        <select id="selectSignalDirection" class="ctrl-spec-input">
                                            <option value="input">input (入力)</option>
                                            <option value="output">output (出力)</option>
                                            <option value="internal">internal (内部)</option>
                                        </select>
                                    </div>

                                    <div class="form-group ctrl-spec-form-col">
                                        <label for="inputSignalAddress" class="ctrl-spec-label">アドレス <span class="text-danger">*</span></label>
                                        <div class="ctrl-spec-flex-row">
                                            <input type="text" id="inputSignalAddress" placeholder="例: %IX0.0, %QX0.0" style="flex: 1; padding: 6px; border: 1px solid #ccc; border-radius: 4px; font-size: 0.9em;">
                                            <button id="btnControlSpecAutoAssignAddress" type="button" class="secondary" style="padding: 6px 10px; font-weight: bold; border-radius: 4px;">自動採番</button>
                                        </div>
                                    </div>

                                    <div class="form-row ctrl-spec-flex-gap">
                                        <div class="form-group ctrl-spec-form-col1 ctrl-spec-form-col">
                                            <label class="ctrl-spec-label">データ型</label>
                                            <select id="selectSignalDataType" class="ctrl-spec-input">
                                                <option value="BOOL">BOOL</option>
                                                <option value="REAL">REAL</option>
                                                <option value="LREAL">LREAL</option>
                                                <option value="DINT">DINT</option>
                                                <option value="UDINT">UDINT</option>
                                                <option value="INT">INT</option>
                                                <option value="UINT">UINT</option>
                                                <option value="WORD">WORD</option>
                                                <option value="DWORD">DWORD</option>
                                            </select>
                                        </div>
                                        <div class="form-group ctrl-spec-form-col1 ctrl-spec-form-col">
                                            <label for="selectSignalActiveState" class="ctrl-spec-label">Active状態</label>
                                            <select id="selectSignalActiveState" class="ctrl-spec-input">
                                                <option value="TRUE">TRUE</option>
                                                <option value="FALSE">FALSE</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="form-group ctrl-spec-form-col">
                                        <label for="inputSignalActuatorId" class="ctrl-spec-label">所属アクチュエータID</label>
                                        <input type="text" id="inputSignalActuatorId" placeholder="例: Pusher_1" class="ctrl-spec-input">
                                    </div>

                                    <div class="form-group ctrl-spec-form-col">
                                        <label for="textareaSignalDesc" class="ctrl-spec-label">説明</label>
                                        <textarea id="textareaSignalDesc" placeholder="信号の詳細な説明や用途" style="padding: 6px; border: 1px solid #ccc; border-radius: 4px; font-size: 0.9em; resize: vertical; min-height: 50px;"></textarea>
                                    </div>

                                    <div class="form-actions ctrl-spec-form-actions">
                                        <button id="btnControlSpecCancelSignal" type="button" class="secondary secondary">キャンセル</button>
                                        <button id="btnControlSpecSaveSignal" type="button" class="primary" style="background: #28a745;">保存</button>
                                    </div>
                                </div>
                            </div>

                            <!-- アクチュエータ定義タブ -->
                            <div id="control-spec-tabpanel-actuators" class="control-spec-tabpanel panel" role="tabpanel" aria-hidden="true" style="height: 100%; display: none; flex-direction: row; gap: 15px; padding: 10px;">
                                <!-- 左：アクチュエータ一覧テーブル -->
                                <div class="control-spec-left-panel" style="flex: 5; display: flex; flex-direction: column; min-width: 0;">
                                    <div class="control-spec-toolbar ctrl-spec-toolbar-mb">
                                        <button id="btnControlSpecAddActuator" type="button" class="primary">＋ アクチュエータ追加</button>
                                        <span class="help ctrl-spec-panel-help">アクチュエータおよびその動作（アクション）を定義します。</span>
                                        <span id="controlSpecActuatorsMeta" class="help ctrl-spec-meta-right"></span>
                                    </div>
                                    <div class="control-spec-table-wrapper ctrl-spec-scroll-y">
                                        <table class="control-spec-table ctrl-spec-table">
                                            <thead>
                                                <tr class="ctrl-spec-thead-tr">
                                                    <th class="ctrl-spec-th">ID</th>
                                                    <th class="ctrl-spec-th">名称</th>
                                                    <th class="ctrl-spec-th">種類</th>
                                                    <th class="ctrl-spec-th">制御方式</th>
                                                    <th class="ctrl-spec-th">アクション数</th>
                                                    <th class="ctrl-spec-th ctrl-spec-th-action">操作</th>
                                                </tr>
                                            </thead>
                                            <tbody id="controlSpecActuatorsTableBody">
                                                <!-- 行データが動的に挿入されます -->
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                
                                <!-- 右：追加・編集フォーム -->
                                <div id="controlSpecActuatorFormPanel" class="control-spec-right-panel" style="flex: 5; border: 1px solid #ddd; border-radius: 6px; padding: 15px; background: #fdfdfd; display: flex; flex-direction: column; gap: 12px; min-width: 320px; box-shadow: 0 1px 3px rgba(0,0,0,0.05); overflow-y: auto;">
                                    <h3 id="controlSpecActuatorFormTitle" class="ctrl-spec-section-title">アクチュエータを追加</h3>
                                    <div id="controlSpecActuatorFormError" class="error-msg ctrl-spec-error-msg"></div>

                                    <!-- 基本情報 -->
                                    <div class="form-group ctrl-spec-form-col">
                                        <label for="inputActuatorId" class="ctrl-spec-label">アクチュエータID <span class="text-danger">*</span></label>
                                        <input id="inputActuatorId" type="text" placeholder="未入力なら保存時に自動採番" class="ctrl-spec-input">
                                    </div>

                                    <div class="form-group ctrl-spec-form-col">
                                        <label for="inputActuatorName" class="ctrl-spec-label">名称 <span class="text-danger">*</span></label>
                                        <input id="inputActuatorName" type="text" placeholder="例: プッシャー1" class="ctrl-spec-input">
                                    </div>

                                    <div class="form-group ctrl-spec-form-col">
                                        <label for="selectActuatorType" class="ctrl-spec-label">種類 <span class="text-danger">*</span></label>
                                        <select id="selectActuatorType" class="ctrl-spec-input">
                                            <option value="pneumaticCylinder">空圧シリンダ</option>
                                            <option value="hydraulicCylinder">油圧シリンダ</option>
                                            <option value="electricCylinder">電動シリンダ</option>
                                            <option value="motor">モータ</option>
                                            <option value="chuck">チャック</option>
                                            <option value="vacuum">バキューム</option>
                                            <option value="heater">ヒータ</option>
                                            <option value="generic">汎用I/O</option>
                                        </select>
                                    </div>

                                    <div class="form-group ctrl-spec-form-col">
                                        <label for="selectActuatorMotorControlType" class="ctrl-spec-label">モータ制御種別</label>
                                        <select id="selectActuatorMotorControlType" class="ctrl-spec-input">
                                            <option value="speedControl">速度指定モータ</option>
                                            <option value="pulseCommand">パルスモータ（コマンド入力）</option>
                                            <option value="pulseTrain">パルスモータ（パルス入力）</option>
                                            <option value="servo">サーボモータ</option>
                                            <option value="inverter">インバータ</option>
                                        </select>
                                    </div>

                                    <div class="form-group ctrl-spec-form-col">
                                        <label for="selectActuatorPneumaticValveMode" class="ctrl-spec-label">ソレノイド方式</label>
                                        <select id="selectActuatorPneumaticValveMode" class="ctrl-spec-input">
                                            <option value="doubleSolenoid">両ソレノイド</option>
                                            <option value="singleSolenoid">片ソレノイド</option>
                                        </select>
                                        <div class="text-muted-sm" style="margin-top: 4px;">片ソレノイドは前進で setOutputs、後退で resetOutputs を使います。</div>
                                    </div>

                                    <div id="controlSpecActuatorValveModelPanel" style="display: flex; flex-direction: column; gap: 10px; padding: 10px; border: 1px solid #e5e7eb; border-radius: 6px; background: #fafcff;">
                                        <div style="font-size: 0.88em; font-weight: 600; color: #334155;">弁モデル</div>
                                        <div id="controlSpecActuatorValvePresetRow" class="form-group ctrl-spec-form-col" style="margin: 0;">
                                            <label for="selectActuatorValvePreset" class="ctrl-spec-label">プリセット</label>
                                            <div>
                                                <select id="selectActuatorValvePreset" class="ctrl-spec-input">
                                                    <option value="">選択してください</option>
                                                    <option value="doubleHoldStop">5/2 両ソレ / 停止=保持</option>
                                                    <option value="doubleOffStop">5/2 両ソレ / 停止=両OFF</option>
                                                    <option value="singlePositiveHoldStop">5/2 片ソレ(通電で前進/上昇) / 停止=保持</option>
                                                    <option value="singlePositiveOffStop">5/2 片ソレ(通電で前進/上昇) / 停止=OFF</option>
                                                    <option value="singleNegativeHoldStop">5/2 片ソレ(通電で後退/下降) / 停止=保持</option>
                                                    <option value="singleNegativeOffStop">5/2 片ソレ(通電で後退/下降) / 停止=OFF</option>
                                                </select>
                                            </div>
                                            <div class="text-muted-sm" style="margin-top: 4px;">出力名は残したまま、方式・通電方向・動作表をまとめて切り替えます。</div>
                                        </div>
                                        <div id="controlSpecActuatorValveDoubleOutputs" class="form-group ctrl-spec-form-col" style="margin: 0;">
                                            <label for="inputActuatorValvePositiveOutput" class="ctrl-spec-label">前進側 / 上昇側 出力</label>
                                            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 8px;">
                                                <input id="inputActuatorValvePositiveOutput" type="text" placeholder="未入力なら成果物生成時に自動採番" class="ctrl-spec-input">
                                                <input id="inputActuatorValveNegativeOutput" type="text" placeholder="未入力なら成果物生成時に自動採番" class="ctrl-spec-input">
                                            </div>
                                            <div class="text-muted-sm" style="margin-top: 4px;">未入力なら成果物生成時に自動採番します。左が前進側 / 上昇側、右が後退側 / 下降側です。</div>
                                        </div>
                                        <div id="controlSpecActuatorValveSingleOutput" class="form-group ctrl-spec-form-col" style="margin: 0;">
                                            <label for="inputActuatorValveSingleOutput" class="ctrl-spec-label">片ソレノイド出力</label>
                                            <input id="inputActuatorValveSingleOutput" type="text" placeholder="未入力なら成果物生成時に自動採番" class="ctrl-spec-input">
                                        </div>
                                        <div id="controlSpecActuatorValveSingleDirection" class="form-group ctrl-spec-form-col" style="margin: 0;">
                                            <label for="selectActuatorValveSingleActiveDirection" class="ctrl-spec-label">片ソレノイド通電方向</label>
                                            <select id="selectActuatorValveSingleActiveDirection" class="ctrl-spec-input">
                                                <option value="positive">通電で前進 / 上昇</option>
                                                <option value="negative">通電で後退 / 下降</option>
                                            </select>
                                        </div>
                                        <div style="overflow-x: auto;">
                                            <table style="width: 100%; border-collapse: collapse; font-size: 0.85em;">
                                                <thead>
                                                    <tr>
                                                        <th style="text-align: left; padding: 6px 4px; border-bottom: 1px solid #dbe3ef;">動作</th>
                                                        <th class="control-spec-valve-double-cell" style="text-align: left; padding: 6px 4px; border-bottom: 1px solid #dbe3ef;">前進側 / 上昇側</th>
                                                        <th class="control-spec-valve-double-cell" style="text-align: left; padding: 6px 4px; border-bottom: 1px solid #dbe3ef;">後退側 / 下降側</th>
                                                        <th class="control-spec-valve-single-cell" style="text-align: left; padding: 6px 4px; border-bottom: 1px solid #dbe3ef;">片ソレノイド</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td style="padding: 6px 4px;">前進 / 上昇</td>
                                                        <td class="control-spec-valve-double-cell" style="padding: 6px 4px;"><select id="selectActuatorValveStateExtendPositive" class="ctrl-spec-input-sm"><option value="on" selected>ON</option><option value="off">OFF</option><option value="hold">保持</option></select></td>
                                                        <td class="control-spec-valve-double-cell" style="padding: 6px 4px;"><select id="selectActuatorValveStateExtendNegative" class="ctrl-spec-input-sm"><option value="on">ON</option><option value="off" selected>OFF</option><option value="hold">保持</option></select></td>
                                                        <td class="control-spec-valve-single-cell" style="padding: 6px 4px;"><select id="selectActuatorValveStateExtendSingle" class="ctrl-spec-input-sm"><option value="on" selected>ON</option><option value="off">OFF</option><option value="hold">保持</option></select></td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding: 6px 4px;">後退 / 下降</td>
                                                        <td class="control-spec-valve-double-cell" style="padding: 6px 4px;"><select id="selectActuatorValveStateRetractPositive" class="ctrl-spec-input-sm"><option value="on">ON</option><option value="off" selected>OFF</option><option value="hold">保持</option></select></td>
                                                        <td class="control-spec-valve-double-cell" style="padding: 6px 4px;"><select id="selectActuatorValveStateRetractNegative" class="ctrl-spec-input-sm"><option value="on" selected>ON</option><option value="off">OFF</option><option value="hold">保持</option></select></td>
                                                        <td class="control-spec-valve-single-cell" style="padding: 6px 4px;"><select id="selectActuatorValveStateRetractSingle" class="ctrl-spec-input-sm"><option value="on">ON</option><option value="off" selected>OFF</option><option value="hold">保持</option></select></td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding: 6px 4px;">停止</td>
                                                        <td class="control-spec-valve-double-cell" style="padding: 6px 4px;"><select id="selectActuatorValveStateStopPositive" class="ctrl-spec-input-sm"><option value="on">ON</option><option value="off">OFF</option><option value="hold" selected>保持</option></select></td>
                                                        <td class="control-spec-valve-double-cell" style="padding: 6px 4px;"><select id="selectActuatorValveStateStopNegative" class="ctrl-spec-input-sm"><option value="on">ON</option><option value="off">OFF</option><option value="hold" selected>保持</option></select></td>
                                                        <td class="control-spec-valve-single-cell" style="padding: 6px 4px;"><select id="selectActuatorValveStateStopSingle" class="ctrl-spec-input-sm"><option value="on">ON</option><option value="off">OFF</option><option value="hold" selected>保持</option></select></td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding: 6px 4px;">非常停止</td>
                                                        <td class="control-spec-valve-double-cell" style="padding: 6px 4px;"><select id="selectActuatorValveStateEmergencyPositive" class="ctrl-spec-input-sm"><option value="on">ON</option><option value="off" selected>OFF</option><option value="hold">保持</option></select></td>
                                                        <td class="control-spec-valve-double-cell" style="padding: 6px 4px;"><select id="selectActuatorValveStateEmergencyNegative" class="ctrl-spec-input-sm"><option value="on">ON</option><option value="off" selected>OFF</option><option value="hold">保持</option></select></td>
                                                        <td class="control-spec-valve-single-cell" style="padding: 6px 4px;"><select id="selectActuatorValveStateEmergencySingle" class="ctrl-spec-input-sm"><option value="on">ON</option><option value="off" selected>OFF</option><option value="hold">保持</option></select></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    <div class="form-group ctrl-spec-form-col">
                                        <label for="selectActuatorControlMethod" class="ctrl-spec-label">制御方式 <span class="text-danger">*</span></label>
                                        <select id="selectActuatorControlMethod" class="ctrl-spec-input">
                                            <option value="discreteIo">discreteIo (I/O制御)</option>
                                            <option value="plcopenMotion">plcopenMotion (PLCopen Motion)</option>
                                            <option value="plcopenFluidPower">plcopenFluidPower (PLCopen Fluid Power)</option>
                                            <option value="vendorFunction">vendorFunction (ベンダー機能)</option>
                                        </select>
                                    </div>

                                    <div class="form-group ctrl-spec-form-col">
                                        <label for="inputActuatorAxisRef" class="ctrl-spec-label">軸参照名 (Axis)</label>
                                        <input id="inputActuatorAxisRef" type="text" placeholder="例: Axis_Pusher" class="ctrl-spec-input">
                                    </div>

                                    <!-- アクション一覧と追加 -->
                                    <div style="border-top: 1px solid #eee; padding-top: 10px; margin-top: 5px;">
                                        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
                                            <h4 style="margin: 0; font-size: 1em; color: #444;">アクション定義</h4>
                                            <button id="btnControlSpecAddAction" type="button" style="padding: 4px 8px; font-size: 0.8em; font-weight: bold; border-radius: 4px; border: 1px solid #007bff; background: #fff; color: #007bff; cursor: pointer;">＋ アクション追加</button>
                                        </div>
                                        <div id="controlSpecActionList" style="display: flex; flex-direction: column; gap: 5px; margin-bottom: 10px;">
                                            <!-- アクション一覧が動的に描画されます -->
                                        </div>
                                    </div>

                                    <!-- アクション詳細編集用カード (選択時のみ表示) -->
                                    <div id="controlSpecActionDetailCard" style="border: 1px solid #ddd; border-radius: 6px; padding: 10px; background: #fdfdfd; display: none; flex-direction: column; gap: 8px;">
                                        <h5 id="controlSpecActionDetailTitle" style="margin: 0; font-size: 0.9em; color: #333; border-bottom: 1px solid #eee; padding-bottom: 5px;">アクション編集</h5>
                                        
                                        <div class="form-group ctrl-spec-form-col-sm">
                                            <label for="inputActionId" class="ctrl-spec-label-sm">アクションID <span class="text-danger">*</span></label>
                                            <input id="inputActionId" type="text" placeholder="例: Extend" class="ctrl-spec-input-sm">
                                        </div>

                                        <div class="form-group ctrl-spec-form-col-sm">
                                            <label for="inputActionName" class="ctrl-spec-label-sm">名称 <span class="text-danger">*</span></label>
                                            <input id="inputActionName" type="text" list="actionNamePresetList" placeholder="例: 前進" class="ctrl-spec-input-sm">
                                            <datalist id="actionNamePresetList">
                                                <option value="前進"></option>
                                                <option value="後退"></option>
                                                <option value="上昇"></option>
                                                <option value="下降"></option>
                                                <option value="チャック"></option>
                                                <option value="アンチャック"></option>
                                                <option value="ON"></option>
                                                <option value="OFF"></option>
                                                <option value="正転"></option>
                                                <option value="逆転"></option>
                                                <option value="停止"></option>
                                                <option value="原点復帰"></option>
                                                <option value="位置決め"></option>
                                                <option value="吸着"></option>
                                                <option value="吸着破壊"></option>
                                            </datalist>
                                        </div>

                                        <div class="form-group ctrl-spec-form-col-sm">
                                            <label for="selectActionCompletionMode" class="ctrl-spec-label-sm">完了方式 <span class="text-muted-sm">(discrete I/O向け)</span></label>
                                            <select id="selectActionCompletionMode" class="ctrl-spec-input-sm">
                                                <option value="sensor">センサ監視</option>
                                                <option value="timer">タイマ完了</option>
                                                <option value="ignore">完了待ちなし</option>
                                            </select>
                                        </div>

                                        <div class="form-group ctrl-spec-form-col-sm">
                                            <label for="inputActionTimeoutSec" class="ctrl-spec-label-sm">タイムアウト (秒) <span class="text-muted-sm">(0: 無効)</span></label>
                                            <input id="inputActionTimeoutSec" type="number" min="0" step="1" value="0" class="ctrl-spec-input-sm">
                                        </div>

                                        <div class="form-row ctrl-spec-flex-row">
                                            <div class="form-group ctrl-spec-form-col1 ctrl-spec-form-col-sm">
                                                <label for="selectActionPlcopenFamily" class="ctrl-spec-label-sm">PLCopen分類</label>
                                                <select id="selectActionPlcopenFamily" class="ctrl-spec-input-sm">
                                                    <option value="">未使用</option>
                                                    <option value="motion">Motion</option>
                                                    <option value="fluidPower">Fluid Power</option>
                                                </select>
                                            </div>
                                            <div class="form-group ctrl-spec-form-col1 ctrl-spec-form-col-sm">
                                                <label for="inputActionPlcopenFbName" class="ctrl-spec-label-sm">FB名</label>
                                                <input id="inputActionPlcopenFbName" type="text" placeholder="例: MC_MoveAbsolute" class="ctrl-spec-input-sm">
                                            </div>
                                        </div>

                                        <div class="form-row ctrl-spec-flex-row">
                                            <div class="form-group ctrl-spec-form-col1 ctrl-spec-form-col-sm">
                                                <label for="inputActionExecuteSignal" class="ctrl-spec-label-sm">Execute信号</label>
                                                <input id="inputActionExecuteSignal" type="text" placeholder="例: MoveExecute" class="ctrl-spec-input-sm">
                                            </div>
                                            <div class="form-group ctrl-spec-form-col1 ctrl-spec-form-col-sm">
                                                <label for="inputActionDoneStatusSignal" class="ctrl-spec-label-sm">Done信号</label>
                                                <input id="inputActionDoneStatusSignal" type="text" placeholder="例: MoveDone" class="ctrl-spec-input-sm">
                                            </div>
                                        </div>

                                        <div class="form-row ctrl-spec-flex-row">
                                            <div class="form-group ctrl-spec-form-col1 ctrl-spec-form-col-sm">
                                                <label for="inputActionBusySignal" class="ctrl-spec-label-sm">Busy信号</label>
                                                <input id="inputActionBusySignal" type="text" placeholder="例: MoveBusy" class="ctrl-spec-input-sm">
                                            </div>
                                            <div class="form-group ctrl-spec-form-col1 ctrl-spec-form-col-sm">
                                                <label for="inputActionErrorSignal" class="ctrl-spec-label-sm">Error信号</label>
                                                <input id="inputActionErrorSignal" type="text" placeholder="例: MoveError" class="ctrl-spec-input-sm">
                                            </div>
                                        </div>

                                        <div class="form-group ctrl-spec-form-col-sm">
                                            <label for="inputActionErrorIdSignal" class="ctrl-spec-label-sm">ErrorID信号</label>
                                            <input id="inputActionErrorIdSignal" type="text" placeholder="例: MoveErrorID" class="ctrl-spec-input-sm">
                                        </div>

                                        <div class="form-row ctrl-spec-flex-row">
                                            <div class="form-group ctrl-spec-form-col1 ctrl-spec-form-col-sm">
                                                <label for="inputActionPositionParam" class="ctrl-spec-label-sm">Position</label>
                                                <input id="inputActionPositionParam" type="text" placeholder="例: TargetPosition" class="ctrl-spec-input-sm">
                                            </div>
                                            <div class="form-group ctrl-spec-form-col1 ctrl-spec-form-col-sm">
                                                <label for="inputActionVelocityParam" class="ctrl-spec-label-sm">Velocity</label>
                                                <input id="inputActionVelocityParam" type="text" placeholder="例: MoveVelocity" class="ctrl-spec-input-sm">
                                            </div>
                                        </div>

                                        <div class="form-group ctrl-spec-form-col-sm">
                                            <label for="selectActionSetOutput" class="ctrl-spec-label-sm">コマンド出力 (setOutputs) <span class="text-muted-sm">(1件のみ)</span></label>
                                            <select id="selectActionSetOutput" class="ctrl-spec-input-sm">
                                                <!-- output信号が動的に挿入されます -->
                                            </select>
                                        </div>

                                        <div class="form-group ctrl-spec-form-col-sm">
                                            <label for="selectActionResetOutput" class="ctrl-spec-label-sm">リセット出力 (resetOutputs) <span class="text-muted-sm">(1件のみ)</span></label>
                                            <select id="selectActionResetOutput" class="ctrl-spec-input-sm">
                                                <!-- output信号が動的に挿入されます -->
                                            </select>
                                        </div>

                                        <div class="form-group ctrl-spec-form-col-sm">
                                            <label for="selectActionDoneSignal" class="ctrl-spec-label-sm">完了条件信号 (doneConditions)</label>
                                            <select id="selectActionDoneSignal" class="ctrl-spec-input-sm">
                                                <!-- input信号が動的に挿入されます -->
                                            </select>
                                        </div>

                                        <div class="form-group ctrl-spec-form-col-sm">
                                            <label for="selectActionDoneValue" class="ctrl-spec-label-sm">完了時の状態</label>
                                            <select id="selectActionDoneValue" class="ctrl-spec-input-sm">
                                                <option value="TRUE">TRUE (ON)</option>
                                                <option value="FALSE">FALSE (OFF)</option>
                                            </select>
                                        </div>

                                        <div class="form-group ctrl-spec-form-col-sm">
                                            <label for="selectActionFaultSignal" class="ctrl-spec-label-sm">異常条件信号 (faultConditions)</label>
                                            <select id="selectActionFaultSignal" class="ctrl-spec-input-sm">
                                                <!-- input信号が動的に挿入されます -->
                                            </select>
                                        </div>

                                        <div class="form-group ctrl-spec-form-col-sm">
                                            <label for="selectActionFaultValue" class="ctrl-spec-label-sm">異常時の状態</label>
                                            <select id="selectActionFaultValue" class="ctrl-spec-input-sm">
                                                <option value="TRUE">TRUE (ON)</option>
                                                <option value="FALSE">FALSE (OFF)</option>
                                            </select>
                                        </div>
                                        
                                        <div style="display: flex; justify-content: flex-end; gap: 5px; margin-top: 5px;">
                                            <button id="btnControlSpecSaveActionDetail" type="button" style="padding: 4px 8px; font-size: 0.8em; font-weight: bold; border-radius: 4px; border: none; background: #28a745; color: #fff; cursor: pointer;">反映</button>
                                        </div>
                                    </div>

                                    <div class="form-actions" style="margin-top: 10px; display: flex; gap: 8px; justify-content: flex-end; border-top: 1px solid #eee; padding-top: 10px;">
                                        <button id="btnControlSpecCancelActuator" type="button" class="secondary secondary">キャンセル</button>
                                        <button id="btnControlSpecSaveActuator" type="button" class="primary" style="background: #28a745;">保存</button>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- 成果物タブ -->
                            <div id="control-spec-tabpanel-outputs" class="control-spec-tabpanel panel" role="tabpanel" aria-hidden="true" class="ctrl-spec-tabpanel-col">
                                <div class="control-spec-toolbar ctrl-spec-toolbar-flex">
                                    <h3 class="ctrl-spec-panel-title">I/O表</h3>
                                    <span id="controlSpecIoTableMeta" class="help ctrl-spec-help-text"></span>
                                    <button id="btnControlSpecExportIoCsv" type="button" class="secondary" style="margin-left: auto; padding: 6px 12px; font-weight: bold; border-radius: 4px;">CSV出力</button>
                                    <button id="btnControlSpecExportIoJson" type="button" class="secondary" style="padding: 6px 12px; font-weight: bold; border-radius: 4px;">JSON出力</button>
                                </div>
                                <div class="control-spec-table-wrapper ctrl-spec-scroll-panel">
                                    <table class="control-spec-table ctrl-spec-table">
                                        <thead>
                                            <tr class="ctrl-spec-thead-tr">
                                                <th class="ctrl-spec-th">方向</th>
                                                <th class="ctrl-spec-th">アドレス</th>
                                                <th class="ctrl-spec-th">信号ID</th>
                                                <th class="ctrl-spec-th">信号名</th>
                                                <th class="ctrl-spec-th">用途</th>
                                                <th class="ctrl-spec-th">参照元 step</th>
                                            </tr>
                                        </thead>
                                        <tbody id="controlSpecIoTableBody">
                                            <tr>
                                                <td colspan="6" class="ctrl-spec-empty-cell">
                                                    I/O表はまだ生成されていません。
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="control-spec-toolbar ctrl-spec-toolbar-sep">
                                    <h3 class="ctrl-spec-panel-title">弁モデル表</h3>
                                    <span id="controlSpecValveModelMeta" class="help ctrl-spec-help-text"></span>
                                </div>
                                <div class="control-spec-table-wrapper ctrl-spec-scroll-panel">
                                    <table class="control-spec-table ctrl-spec-table">
                                        <thead>
                                            <tr class="ctrl-spec-thead-tr">
                                                <th class="ctrl-spec-th">アクチュエータID</th>
                                                <th class="ctrl-spec-th">名称</th>
                                                <th class="ctrl-spec-th">方式</th>
                                                <th class="ctrl-spec-th">出力割付</th>
                                                <th class="ctrl-spec-th">前進 / 上昇</th>
                                                <th class="ctrl-spec-th">後退 / 下降</th>
                                                <th class="ctrl-spec-th">停止 / 非常停止</th>
                                            </tr>
                                        </thead>
                                        <tbody id="controlSpecValveModelBody">
                                            <tr>
                                                <td colspan="7" class="ctrl-spec-empty-cell">
                                                    弁モデル表はまだ生成されていません。
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="control-spec-toolbar ctrl-spec-toolbar-sep">
                                    <h3 class="ctrl-spec-panel-title">動作一覧</h3>
                                    <span id="controlSpecActionStepsMeta" class="help ctrl-spec-help-text"></span>
                                </div>
                                <div class="control-spec-table-wrapper ctrl-spec-scroll-panel">
                                    <table class="control-spec-table ctrl-spec-table">
                                        <thead>
                                            <tr class="ctrl-spec-thead-tr">
                                                <th class="ctrl-spec-th">Step</th>
                                                <th class="ctrl-spec-th">ノード</th>
                                                <th class="ctrl-spec-th">アクチュエータ</th>
                                                <th class="ctrl-spec-th">アクション</th>
                                                <th class="ctrl-spec-th">指令</th>
                                                <th class="ctrl-spec-th">完了条件</th>
                                                <th class="ctrl-spec-th">timeout</th>
                                            </tr>
                                        </thead>
                                        <tbody id="controlSpecActionStepsBody">
                                            <tr>
                                                <td colspan="7" class="ctrl-spec-empty-cell">
                                                    動作一覧はまだ生成されていません。
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="control-spec-toolbar ctrl-spec-toolbar-sep">
                                    <h3 class="ctrl-spec-panel-title">条件一覧</h3>
                                    <span id="controlSpecConditionStepsMeta" class="help ctrl-spec-help-text"></span>
                                </div>
                                <div class="control-spec-table-wrapper ctrl-spec-scroll-panel">
                                    <table class="control-spec-table ctrl-spec-table">
                                        <thead>
                                            <tr class="ctrl-spec-thead-tr">
                                                <th class="ctrl-spec-th">Step</th>
                                                <th class="ctrl-spec-th">条件名</th>
                                                <th class="ctrl-spec-th">種別</th>
                                                <th class="ctrl-spec-th">条件</th>
                                                <th class="ctrl-spec-th">分岐</th>
                                                <th class="ctrl-spec-th">timeout</th>
                                            </tr>
                                        </thead>
                                        <tbody id="controlSpecConditionStepsBody">
                                            <tr>
                                                <td colspan="6" class="ctrl-spec-empty-cell">
                                                    条件一覧はまだ生成されていません。
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="control-spec-toolbar ctrl-spec-toolbar-sep">
                                    <h3 class="ctrl-spec-panel-title">エラー一覧</h3>
                                    <span id="controlSpecErrorListMeta" class="help ctrl-spec-help-text"></span>
                                </div>
                                <div class="control-spec-table-wrapper ctrl-spec-scroll-panel">
                                    <table class="control-spec-table ctrl-spec-table">
                                        <thead>
                                            <tr class="ctrl-spec-thead-tr">
                                                <th class="ctrl-spec-th">種別</th>
                                                <th class="ctrl-spec-th">Step / Node</th>
                                                <th class="ctrl-spec-th">コード</th>
                                                <th class="ctrl-spec-th">内容</th>
                                                <th class="ctrl-spec-th">対象</th>
                                            </tr>
                                        </thead>
                                        <tbody id="controlSpecErrorListBody">
                                            <tr>
                                                <td colspan="5" class="ctrl-spec-empty-cell">
                                                    エラー一覧はまだ生成されていません。
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            
                            <!-- 検証結果タブ -->
                            <div id="control-spec-tabpanel-findings" class="control-spec-tabpanel panel" role="tabpanel" aria-hidden="true" class="ctrl-spec-tabpanel-col">
                                <div class="control-spec-toolbar ctrl-spec-toolbar-flex">
                                    <h3 class="ctrl-spec-panel-title">検証結果</h3>
                                    <span id="controlSpecFindingsMeta" class="help ctrl-spec-help-text"></span>
                                </div>
                                <div class="control-spec-table-wrapper ctrl-spec-scroll-panel">
                                    <table class="control-spec-table ctrl-spec-table">
                                        <thead>
                                            <tr class="ctrl-spec-thead-tr">
                                                <th class="ctrl-spec-th">severity</th>
                                                <th class="ctrl-spec-th">code</th>
                                                <th class="ctrl-spec-th">message</th>
                                                <th class="ctrl-spec-th">対象</th>
                                            </tr>
                                        </thead>
                                        <tbody id="controlSpecFindingsTableBody">
                                            <tr>
                                                <td colspan="4" class="ctrl-spec-empty-cell">
                                                    制御仕様の検証結果はありません。
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                
`;
